/*
  Varianten-Bilder per Alt-Text-Tag
  Alt-Text enthält "[SKU]" für eine Variante oder "[ALLE]" für alle Varianten.
  Hat eine Variante keine getaggten Bilder, werden alle Bilder angezeigt.
*/
(function () {
  function applyVariantFilter(sectionId, variant) {
    if (!sectionId || !variant) return;

    var sku = (variant.sku || '').toLowerCase();
    var tag = '[' + sku + ']';
    var featuredId = variant.featured_media ? String(variant.featured_media.id) : null;

    var galleries = document.querySelectorAll(
      '[id^="MediaGallery-' + sectionId + '"][data-variant-alt-gallery]'
    );

    galleries.forEach(function (gallery) {
      var items = gallery.querySelectorAll('[data-alt-tags]');
      var hasVariantMedia =
        sku !== '' &&
        Array.prototype.some.call(items, function (el) {
          return el.dataset.altTags.indexOf(tag) !== -1;
        });

      var visibleIds = {};

      items.forEach(function (el) {
        var tags = el.dataset.altTags || '';
        var rawId = el.dataset.rawMediaId;
        var show =
          !hasVariantMedia ||
          tags.indexOf(tag) !== -1 ||
          tags.indexOf('[alle]') !== -1 ||
          rawId === featuredId;

        el.classList.toggle('hide-media', !show);
        if (show) visibleIds[rawId] = true;
      });

      // Zoom-Modal: nur Bilder der aktiven Variante
      var modal = document.getElementById('ProductModal-' + sectionId);
      if (modal) {
        modal.querySelectorAll('[data-media-id]').forEach(function (el) {
          el.classList.toggle('hide-media', !visibleIds[el.dataset.mediaId]);
        });
      }

      // Slider-Zähler und Seiten neu berechnen
      gallery.querySelectorAll('slider-component').forEach(function (slider) {
        if (typeof slider.resetPages === 'function') slider.resetPages();
      });
    });
  }

  document.addEventListener('change', function (event) {
    var picker = event.target.closest('variant-selects, variant-radios');
    if (!picker) return;

    // Dawn setzt currentVariant synchron im eigenen change-Handler
    setTimeout(function () {
      var variant = picker.currentVariant;
      if (!variant && typeof picker.getVariantData === 'function') {
        var selected = Array.from(picker.querySelectorAll('select, fieldset input:checked')).map(function (el) {
          return el.value;
        });
        variant = picker.getVariantData().find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
      }
      applyVariantFilter(picker.dataset.section, variant);
    }, 0);
  });
})();